import {inject, Injectable, signal} from '@angular/core';
import {GetSelectDataParams, SelectData} from "../../../../../../../core/types/records-table.types";
import {propertyLazySelectProductPackageType} from "../configs/product-package-modal-config";
import {
  articleOzonPropertyLazySelect,
  articleWBPropertyLazySelect,
  placePropertyLazySelect
} from "../configs/lazy-select-data-params";
import {ProductPackageModalService} from "./product-package-modal.service";

@Injectable({
  providedIn: 'root'
})
export class ProductPackageSelectDataStateService {
  private productPackageModalService: ProductPackageModalService = inject(ProductPackageModalService);

  private _packageTypeSelectData = signal<Array<SelectData>>([]);
  private _storageLocationSelectData = signal<Array<SelectData>>([]);
  private _articleWBSelectData = signal<Array<SelectData>>([]);
  private _articleOzonSelectedData = signal<Array<SelectData>>([]);
  public packageTypeSelectData = this._packageTypeSelectData.asReadonly();
  public storageLocationSelectData = this._storageLocationSelectData.asReadonly();
  public articleWBSelectData = this._articleWBSelectData.asReadonly();
  public articleOzonSelectedData = this._articleOzonSelectedData.asReadonly();

  public async fetchSelectData(parentId: number): Promise<void> {
    await this.setPackageTypeSelectData();
    await this.setStorageLocationSelectData();
    await this.setArticleWBSelectData(parentId);
    await this.setArticleOzonSelectData(parentId);
  }

  public getSelectDataByKey(key: string): Array<SelectData> {
    const selectData: Record<string, () => Array<SelectData>> = {
      packageType: () => this.packageTypeSelectData(),
      storageLocationType: () => this.storageLocationSelectData(),
      nmId: () => this.articleWBSelectData(),
      sku: () => this.articleOzonSelectedData(),
    };

    return selectData[key]?.() || [];
  }

  private async setPackageTypeSelectData(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectProductPackageType
    };

     await this.productPackageModalService.fetchSelectData(getSelectDataParams)
       .then((data) => this._packageTypeSelectData.set(data));
  }

  private async setStorageLocationSelectData(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: placePropertyLazySelect
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._storageLocationSelectData.set(data));
  }

  private async setArticleWBSelectData(parentId: number): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: articleWBPropertyLazySelect,
      id: parentId
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._articleWBSelectData.set(data));
  }

  private async setArticleOzonSelectData(parentId: number): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: articleOzonPropertyLazySelect,
      id: parentId
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._articleOzonSelectedData.set(data));
  }
}
